export const statusOpts = [
  { label: "Generato", value: "GENERATA" },
  { label: "Effettuato", value: "OK_PSP" },
  { label: "Disponibile", value: "DISPONIBILE" },
  { label: "Usato", value: "USATO" },
  { label: "Rimborsato", value: "RIMBORSATO" },
  { label: "Fallito", value: "FALLITO" }
];
